import { Link } from "react-router-dom";


export function BreadcrumbBar(props) {
    const breadcrumbItems = [];

    breadcrumbItems.push(<Link key="rootItem" to="/">Heliodata</Link>);

    props.levels.forEach(({ link, text, }, idx) => {

        var extraClass = (idx === props.levels.length - 1) ? 'breadcrumbBarLastLink' : '';

        breadcrumbItems.push(<span className="breadcrumbBarSpace" key={`${idx}-space`}> / </span>);
        breadcrumbItems.push(<Link key={`${idx}-item`} to={link} className={extraClass}>{text}</Link>);
    });

    return (
        <div className="breadcrumbBar">
            {breadcrumbItems}
        </div>
    );
}
